import { IonAccordionGroup } from "@ionic/react";
import { useEffect, useState } from "react";
import { v4 } from "uuid";
import BasicPage from "../../components/BasicPage/BasicPage";
import { makeGETRequest } from "../../request/rawRequest";
import AccordionLoaderTheme from "../AccordionLoaderTheme";

export interface Skill {
  _id: string;
  name: string;
  index: number;
  themeIDs: string[];
  quizz?: any;
}

const FormalPratique: React.FC = () => {
  const [skills, setSkills] = useState<Skill[]>([]);

  useEffect(() => {
    setSkills([]);
    makeGETRequest("/skills/videotutorial/unique?type=char&pole=1").then(
      (res: any[]) => {
        const _skills = res.sort((a, b) => a.index - b.index);
        _skills.forEach((skill) => {
          const { name, index, id_themes, _id, quizz } = skill;
          setSkills((old) => [
            ...old,
            {
              _id,
              index,
              name,
              quizz,
              themeIDs: id_themes,
              themes: [],
              hasThemeLoaded: false,
            },
          ]);
        });
      }
    );
  }, []);

  return (
    <BasicPage pathReturn title={"Bienvenue"} subtitle="">
      <IonAccordionGroup>
        {skills.map((skill) => {
          return <AccordionLoaderTheme skill={skill} key={v4()} />;
        })}
      </IonAccordionGroup>

      <div
        style={{
          marginBottom: 100,
        }}
      ></div>
    </BasicPage>
  );
};

export default FormalPratique;
